module.exports = __webpack_public_path__ + "img/FUN HANGOUT HUT MNC NI BOS1 copy 5.330dacd9.jpg";